var _rect, _rect2, _path, _use, _use2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTw = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 800 800"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: -60,
  y: -40,
  width: "100%",
  height: "100%",
  fill: "#fe0000"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: -60,
  y: -40,
  width: "50%",
  height: "50%",
  fill: "#000095"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "tw_svg__a",
  d: "M8 0L0 30-8 0l8-30M0 8l30-8L0-8l-30 8",
  fill: "#fff"
})), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tw_svg__a",
  transform: "rotate(30)"
})), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tw_svg__a",
  transform: "rotate(60)"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  r: 17,
  fill: "#000095"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  r: 15,
  fill: "#fff"
})));
export default SvgTw;